import { render, staticRenderFns } from "./deviceDetails.vue?vue&type=template&id=b86b5a5c&scoped=true"
import script from "./deviceDetails.vue?vue&type=script&lang=js"
export * from "./deviceDetails.vue?vue&type=script&lang=js"
import style0 from "./deviceDetails.vue?vue&type=style&index=0&id=b86b5a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86b5a5c",
  null
  
)

export default component.exports